import { render, staticRenderFns } from "./GStudentRecordFindingsProposalsTable.vue?vue&type=template&id=08b919c4&scoped=true&"
import script from "./GStudentRecordFindingsProposalsTable.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordFindingsProposalsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b919c4",
  null
  
)

export default component.exports